// extracted by mini-css-extract-plugin
export default {"title":"fa8fa7f272","inner_title":"_36acda0cb8","charge_btn":"_9a6f967647"};